import { render, staticRenderFns } from "./foldable.vue?vue&type=template&id=2209ca4c"
import script from "./foldable.vue?vue&type=script&lang=js"
export * from "./foldable.vue?vue&type=script&lang=js"
import style0 from "./foldable.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports